import { render, staticRenderFns } from "./SearchManager.vue?vue&type=template&id=473310a8&"
import script from "./SearchManager.vue?vue&type=script&lang=js&"
export * from "./SearchManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports